type ConfirmationEvent = CustomEvent<{ readonly result: boolean }>;

export class ConfirmationObserver {
  static readonly #eventName = 'confirm';

  readonly #eventTarget = new EventTarget();

  public dispatch(result: boolean) {
    const event: ConfirmationEvent = new CustomEvent(ConfirmationObserver.#eventName, { detail: { result } });
    this.#eventTarget.dispatchEvent(event);
  }

  public subscribe(callback: (result: boolean, unsubscribe: () => void) => void): () => void {
    const unsubscribe = () => {
      // istanbul ignore if
      if (listener == null) {
        return;
      }

      this.#eventTarget.removeEventListener(ConfirmationObserver.#eventName, listener);

      // Listener is set to undefined to prevent memory leaks
      listener = undefined;
    };

    let listener: ((event: Event) => void) | undefined = (event) =>
      callback((event as ConfirmationEvent).detail.result, unsubscribe);

    this.#eventTarget.addEventListener(ConfirmationObserver.#eventName, listener);

    return unsubscribe;
  }
}
